import { IEscrowFileCompleteData } from '../../../types/order/escrow/IEscrowFileCompleteData';
import { IAchPushDisbursementData } from '../../../types/order/escrow/IAchPushDisbursementData';
import { IEscrowWireDisbursementsData } from '../../../types/order/escrow/IEscrowWireDisbursementsData';
import { instanceOfICreateAchAccountData } from './instanceOfIAchAccount';
import {
  IConfirmAchPush,
  IConfirmTransaction,
  IConfirmWireDisbursement,
} from '../../../types/order/escrow/IConfirmTransaction';

export const getConfirmModalData = ({
  achPushDisbursements,
  wireDisbursements: formWireDisbursements,
}: IEscrowFileCompleteData): IConfirmTransaction[] => {
  const achPushes: IConfirmAchPush[] = (achPushDisbursements || [])
    .filter((achPush: IAchPushDisbursementData) => instanceOfICreateAchAccountData(achPush.account))
    .map((achPush: IAchPushDisbursementData) => ({ ...achPush, heading: 'ACH Transfers' }));

  const wireDisbursements: IConfirmWireDisbursement[] = (formWireDisbursements || []).map(
    (wireDisbursement: IEscrowWireDisbursementsData) => ({
      ...wireDisbursement,
      heading: 'Wire Transfers',
    })
  );
  return [...achPushes, ...wireDisbursements];
};
